<div class="container-fluid header py-5">
    <div class="container">
        <div class="row">
            <div class="col">
                <h1 class="text-start mb-0 made-in-usa">SIZING CHART</h1>
                <h2 class="h5 text-start mt-0">HOW TO FIND YOUR MEASUREMENT</h2>
            </div>
        </div>

    </div>
</div>
<div class="container my-4">
    <div class="row">
        <div class="col-md-3">
            <div class="d-flex h-100 align-items-center diagrams flex-column justify-content-around">
                <app-illustration (click)="openDiagram();"></app-illustration>
                <!-- <img (click)="openDiagram(); diagramSrc = 'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/measurements-lg-b.png?v=1744727286'" src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/measurements-lg-b.png?v=1744727286" alt="How to measure your size"
                    class="img-fluid"> -->
                <!-- <div class="img-wrapper position-relative w-100">
                    <img src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Measuring_Diagram_whole_body.svg?v=1743430525"
                        alt="">
                    <svg (click)="openDiagram(); diagramSrc = 'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Measuring_Diagram_whole_body.svg?v=1743430525'"
                        class="magnifying-glass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            d="M10.5 2C5.81 2 2 5.81 2 10.5S5.81 19 10.5 19c4.69 0 8.5-3.81 8.5-8.5S15.19 2 10.5 2zm0 14c-3.06 0-5.5-2.44-5.5-5.5S7.44 5 10.5 5s5.5 2.44 5.5 5.5-2.44 5.5-5.5 5.5z" />
                        <path d="M21.71 20.29l-4-4a1 1 0 00-1.42 1.42l4 4a1 1 0 001.42-1.42z" />
                    </svg>
                </div>
                <div class="img-wrapper position-relative w-100">
                    <img src="https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Measuring_Diagram_bottoms.svg?v=1743523515"
                        alt="">
                    <svg (click)="openDiagram(); diagramSrc = 'https://cdn.shopify.com/s/files/1/0003/4183/5782/files/Measuring_Diagram_bottoms.svg?v=1743523515';"
                        class="magnifying-glass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            d="M10.5 2C5.81 2 2 5.81 2 10.5S5.81 19 10.5 19c4.69 0 8.5-3.81 8.5-8.5S15.19 2 10.5 2zm0 14c-3.06 0-5.5-2.44-5.5-5.5S7.44 5 10.5 5s5.5 2.44 5.5 5.5-2.44 5.5-5.5 5.5z" />
                        <path d="M21.71 20.29l-4-4a1 1 0 00-1.42 1.42l4 4a1 1 0 001.42-1.42z" />
                    </svg>
                </div> -->
            </div>
        </div>
        <div class="col-md-9 size-charts">
            <div style="display:none;" class="size-chart">
                <h1 class="text-uppercase">Women's Op Top / Op Top Pro</h1>
                <table>
                    <thead>
                        <tr>
                            <th>Size</th>
                            <th>XS</th>
                            <th>Small</th>
                            <th>Medium</th>
                            <th>Large</th>
                            <th>X-Large</th>
                            <th>2XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sleeve Length</td>
                            <td>15"-16"</td>
                            <td>16"-17"</td>
                            <td>16.5"-17.5"</td>
                            <td>17.5"-18.5"</td>
                            <td>18"-19"</td>
                            <td>19"-20"</td>
                        </tr>
                        <tr>
                            <td>Body Length</td>
                            <td>25"</td>
                            <td>26"</td>
                            <td>27"</td>
                            <td>28"</td>
                            <td>29"</td>
                            <td>30"</td>
                        </tr>
                        <tr>
                            <td>Chest Width</td>
                            <td>15.5"-17.25"</td>
                            <td>16.5"-18.25"</td>
                            <td>17.5"-19.25"</td>
                            <td>18.5"-19.25"</td>
                            <td>19.5"-21.25"</td>
                            <td>20.5"-22.25"</td>
                        </tr>
                        <tr>
                            <td>Bicep Width</td>
                            <td>6"</td>
                            <td>6.25"</td>
                            <td>6.75"</td>
                            <td>7.25"</td>
                            <td>7.75"</td>
                            <td>8.25"</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="display:none;" class="size-chart">
                <h1 class="text-uppercase">Women's LS Op Top / Op Top Pro</h1>
                <table>
                    <thead>
                        <tr>
                            <th>Size</th>
                            <th>XS</th>
                            <th>Small</th>
                            <th>Medium</th>
                            <th>Large</th>
                            <th>X-Large</th>
                            <th>2XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sleeve Length</td>
                            <td>30"-30.5"</td>
                            <td>32"-32.5"</td>
                            <td>33"-33.5"</td>
                            <td>34"-34.5"</td>
                            <td>35"-35.5"</td>
                            <td>36"-36.5"</td>
                        </tr>
                        <tr>
                            <td>Body Length (Front)</td>
                            <td>25"</td>
                            <td>26"</td>
                            <td>27"</td>
                            <td>28"</td>
                            <td>29"</td>
                            <td>30"</td>
                        </tr>
                        <tr>
                            <td>Chest Width</td>
                            <td>15.5"-17.25"</td>
                            <td>16.5"-18.25"</td>
                            <td>17.5"-19.25"</td>
                            <td>18.5"-19.25"</td>
                            <td>19.5"-21.25"</td>
                            <td>20.5"-22.25"</td>
                        </tr>
                        <tr>
                            <td>Bicep Width</td>
                            <td>6"</td>
                            <td>6.25"</td>
                            <td>6.75"</td>
                            <td>7.25"</td>
                            <td>7.75"</td>
                            <td>8.25"</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="display:none;" class="size-chart">
                <h1 class="text-uppercase">Women's Op Assault Pant</h1>
                <table>
                    <thead>
                        <tr>
                            <th>SIZE</th>
                            <th>WAIST</th>
                            <th>HIP</th>
                            <th>THIGH</th>
                            <th>INSEAM (SHORT)</th>
                            <th>INSEAM (REG)</th>
                            <th>INSEAM (TALL)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>0</td>
                            <td>25"</td>
                            <td>35-38"</td>
                            <td>21"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>26.5"</td>
                            <td>36-39"</td>
                            <td>22"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>28"</td>
                            <td>37-40"</td>
                            <td>23"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>29.5"</td>
                            <td>38-41"</td>
                            <td>24"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>8</td>
                            <td>31"</td>
                            <td>39-42"</td>
                            <td>25"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>32.5"</td>
                            <td>40-43"</td>
                            <td>26"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>34"</td>
                            <td>41-44"</td>
                            <td>27"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td>35.5"</td>
                            <td>42-45"</td>
                            <td>28"</td>
                            <td>29</td>
                            <td>32</td>
                            <td>35</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="size-chart my-5">
                <h1 class="text-uppercase">
                    Op Top/Op Top Pro short sleeve
                </h1>
                <table>
                    <thead>
                        <tr>
                            <th>Size</th>
                            <th>Small</th>
                            <th>Medium</th>
                            <th>Large</th>
                            <th>X-Large</th>
                            <th>2XL</th>
                            <th>3XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sleeve Length</td>
                            <td>18"-19.5"</td>
                            <td>18.5"-20.5"</td>
                            <td>19.25"-21"</td>
                            <td>20"-22"</td>
                            <td>21"-23"</td>
                            <td>22"-24"</td>
                        </tr>
                        <tr>
                            <td>Body Length</td>
                            <td>28”</td>
                            <td>29”</td>
                            <td>30”</td>
                            <td>31”</td>
                            <td>32”</td>
                            <td>33”</td>
                        </tr>
                        <tr>
                            <td>Chest Width</td>
                            <td>20 3/4”</td>
                            <td>21 3/4”</td>
                            <td>22 3/4”</td>
                            <td>23 3/4”</td>
                            <td>24 3/4”</td>
                            <td>25 3/4”</td>
                        </tr>
                        <tr>
                            <td>Bicep Width</td>
                            <td>6 1/2”</td>
                            <td>6 3/4”</td>
                            <td>7”</td>
                            <td>7 1/4”</td>
                            <td>7 1/2”</td>
                            <td>7 3/4"</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="size-chart my-5">
                <h1 class="text-uppercase">Op Top/Op Top Pro Long sleeve</h1>
                <table>
                    <thead>
                        <tr>
                            <th>Size</th>
                            <th>Small</th>
                            <th>Medium</th>
                            <th>Large</th>
                            <th>X-Large</th>
                            <th>2XL</th>
                            <th>3XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sleeve Length</td>
                            <td>33"-34.5"</td>
                            <td>33.5"-35.5"</td>
                            <td>34.25"-36"</td>
                            <td>35"-37"</td>
                            <td>36"-38"</td>
                            <td>37"-39"</td>
                        </tr>
                        <tr>
                            <td>Body Length</td>
                            <td>28”</td>
                            <td>29”</td>
                            <td>30”</td>
                            <td>31”</td>
                            <td>32”</td>
                            <td>33”</td>
                        </tr>
                        <tr>
                            <td>Chest Width</td>
                            <td>20 3/4”</td>
                            <td>21 3/4”</td>
                            <td>22 3/4”</td>
                            <td>23 3/4”</td>
                            <td>24 3/4”</td>
                            <td>25 3/4”</td>
                        </tr>
                        <tr>
                            <td>Bicep Width</td>
                            <td>7”</td>
                            <td>7 1/2”</td>
                            <td>8”</td>
                            <td>8 1/2”</td>
                            <td>9”</td>
                            <td>9 1/2”</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="size-chart mt-3">
                <p>
                    <b>
                        *Inseam Height notation:
                    </b>
                    5'10" AND UNDER: 30” inseam | 5'11" - 6'2": 33” inseam | 6’2” AND ABOVE: 36” INSEAM
                </p>
                <p>
                    <b>
                        *Please advise: if you are in between sizes- choose the larger size. Adjustable straps on the
                        side(s) will help
                        bridge
                        the size gap.
                    </b>
                </p>
            </div>
            <div class="size-chart my-1">
                <h1 class="text-uppercase">Op Assault Pant</h1>
                <table>
                    <thead>
                        <tr>
                            <th>MEASUREMENT</th>
                            <th>30</th>
                            <th>32</th>
                            <th>34</th>
                            <th>36</th>
                            <th>38</th>
                            <th>40</th>
                            <th>42</th>
                            <th>44</th>
                            <th>46</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>HIP</td>
                            <td>18 1/4”</td>
                            <td>19 1/4”</td>
                            <td>20 1/4”</td>
                            <td>21 1/4”</td>
                            <td>22 1/4”</td>
                            <td>23 1/4”</td>
                            <td>24 1/4”</td>
                            <td>25 1/2”</td>
                            <td>26 1/2”</td>
                        </tr>
                        <tr>
                            <td>THIGH</td>
                            <td>11 1/4”</td>
                            <td>12”</td>
                            <td>12 3/4”</td>
                            <td>13 1/2”</td>
                            <td>14 1/4”</td>
                            <td>15”</td>
                            <td>15 3/4”</td>
                            <td>16 1/2”</td>
                            <td>17 1/4”</td>
                        </tr>
                        <tr>
                            <td>KNEE</td>
                            <td>9”</td>
                            <td>9 1/2”</td>
                            <td>10”</td>
                            <td>10 1/4”</td>
                            <td>10 3/4”</td>
                            <td>11”</td>
                            <td>11 1/2”</td>
                            <td>12”</td>
                            <td>12 1/2”</td>
                        </tr>
                        <tr>
                            <td>BOTTOM OPENING</td>
                            <td>8”</td>
                            <td>8 1/4”</td>
                            <td>8 1/2”</td>
                            <td>8 3/4”</td>
                            <td>9”</td>
                            <td>9 1/4”</td>
                            <td>9 1/2”</td>
                            <td>9 3/4”</td>
                            <td>10”</td>
                        </tr>
                        <tr>
                            <td>INSEAM</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                            <td>30" / 33" / 36</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <dialog #diagram class="diagram-modal h-100 w-100 position-fixed top-0 start-0 z-index-9">
        <a class="close" (click)="closeDiagram()">&times;</a>
        <div class="h-100 img-wrapper overflow-y-scroll position-relative w-100">
            <app-illustration></app-illustration>
            <!-- <img class="d-block h-100 w-100" [src]="diagramSrc" (click)="closeDiagram()"> -->

        </div>
    </dialog>

</div>